import { useTheme } from 'styled-components';
import { StyledQuestionCircleOutlined } from './Tooltip.style';
import { Tooltip as TooltipV5, TooltipProps } from 'antd5';

export const Tooltip = (props: TooltipProps) => {
  const theme = useTheme();
  return <TooltipV5 color={theme.tooltipBackground} {...props} />;
};

export const TooltipWithQuestionIcon = ({ message }: { message: JSX.Element | string }) => {
  return (
    <Tooltip style={{ margin: '0 0.5rem' }} title={message}>
      <StyledQuestionCircleOutlined />
    </Tooltip>
  );
};
